import { render } from "./evidence.vue?vue&type=template&id=20f689f4&scoped=true"
import script from "./evidence.vue?vue&type=script&lang=js"
export * from "./evidence.vue?vue&type=script&lang=js"

import "./evidence.vue?vue&type=style&index=0&id=20f689f4&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f689f4"]])

export default __exports__